import { unifiedClient } from '@/lib/unified-fetch';
import type { components } from '@/@types/openapi-admin';
import { useQuery, useMutation, UseQueryOptions } from '@tanstack/react-query';
// Import response types are now defined in typings.d.ts using OpenAPI schemas

export type TopUpData = components['schemas']['def-44'];
export type TopUpFilter = components['schemas']['def-43'];

const queryKey = 'topup'

export const useTopUp = (startDate?: string, endDate?: string, options?: Partial<UseQueryOptions>) => {
  let opts = {
    queryKey: [queryKey],
    queryFn: async () => {
      const filter: TopUpFilter = {};
    
      if (startDate) {
        filter.date_gte = startDate;
      }
      
      if (endDate) {
        filter.date_lte = endDate;
      }

      const response = await unifiedClient.admin.GET('/event_Topup/', {
        params: {
          query: {
            limit: 1000,
            offset: 0,
            filter: Object.keys(filter).length > 0 ? filter : undefined,
          },
        },
      });

      if (response.data) {
        return response.data;
      }
      return [];
    }
  }
  Object.assign(opts, options);

  return useQuery(opts)
}

/**
 * Upload CSV file for topup import
 */
export const useTopupImport = () => {
  return useMutation({
    mutationFn: async (file: File): Promise<API.TopupImportResponse> => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await unifiedClient.app.POST('/topups/import', {
        body: formData as any,
        headers: {
          // Don't set Content-Type, let the browser set it for FormData
        },
      });

      return response.data as API.TopupImportResponse;
    },
  });
};

/**
 * Hook for topup import with loading state and error handling
 */
export const useTopupImportWithState = () => {
  const mutation = useTopupImport();

  return {
    importTopups: mutation.mutate,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    data: mutation.data,
    reset: mutation.reset,
  };
};